import React from 'react';
import { Link } from 'react-router-dom';
import { BOOKING_ROUTES } from '../../data/bookingExperienceData';
import '../../styles/booking-experience.scss';

function PlanCompletionPanel() {
	return (
		<aside className="plan-booking-panel" aria-label="Booking help">
			<p className="plan-booking-panel__title">Need help putting everything together?</p>
			<div className="plan-booking-panel__links">
				<Link to={BOOKING_ROUTES.group} className="plan-booking-panel__link">Join a Group Departure</Link>
				<Link to={BOOKING_ROUTES.private} className="plan-booking-panel__link">Travel Privately</Link>
			</div>
		</aside>
	);
}

export default PlanCompletionPanel;
